<template>
    <div class="modal-mask" @click="close()">
        <div class="modal-wrapper">
            <div class="modal-container" @click.stop="">

                <div class="modal-header">
                    <slot name="header">
                        <h3 class="modal-title" id="exampleModalLabel">{{ $t("quiz.add_list_modal_title") }}</h3>
                        <img style="cursor: pointer;" @click="close()" src="@/assets/Quiz/close.svg" alt="">
                    </slot>

                </div>

                <div class="modal-body">
                    <slot name="body">

                    </slot>
                </div>

                <div class="modal-footer">
                    <slot name="footer">

                    </slot>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
export default {
    data() {
        return {

        }
    },
    created() {

    },
    methods: {
        close() {
            this.$store.commit("setShowNewListModal", false)
        }

    }
}
</script>
<style scoped>
.modal-mask {
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 30dvw;
    height: 600px;
    margin: 0px auto;
    padding: 20px 20px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    color: black;
    overflow: auto;
}

@media only screen and (max-width: 850px) {
    .modal-container {
        width: 80dvw;
    }
}

.modal-header h3 {
    color: var(--Black-Gray, #696969);
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.modal-body {
    margin: 10px 0;
}

.modal-default-button {
    float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}

.modal-enter-active .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>